import moment from 'jalali-moment';
import { useEffect } from 'react';
import { useState } from 'react';
import Axios from '../utils/axios';
import { Link, useHistory } from 'react-router-dom';
import { DatePicker } from 'jalali-react-datepicker';
import { useQuery } from '../utils/hooks';
import { Patient } from '../redux/types';

type Props = {
	history?: boolean;
};
type UsersType = {
	patient: Patient;
	created: string;
};
export const Daily: React.FunctionComponent<Props> = (props) => {
	const { history } = props;
	const routerHistory = useHistory();
	// state for date
	const query = useQuery();

	const queryDate = query.get('date') || moment().format('YYYY-MM-DD');
	const [date, setDate] = useState(queryDate);

	const [users, setUsers] = useState<Partial<UsersType[]>>([]);

	useEffect(() => {
		const getUsers = async () => {
			let url = 'patient/daily';
			if (date) {
				url += `?date=${date}`;
			}
			const res = await Axios.get(url);
			setUsers(res.data);
		};
		getUsers();
	}, [date]);

	return (
		<div className="grid grid-flow-row gap-3 mx-auto mt-5 ">
			{/* callout show today date in farsi */}
			<div
				className="px-4 py-3 mx-3 text-blue-700 bg-blue-100 border border-blue-500 rounded-md shadow"
				role="alert"
			>
				<p className="text-sm">
					تاریخ امروز:{' '}
					{new Date().toLocaleString('fa', {
						year: 'numeric',
						weekday: 'long',
						month: 'long',
						day: 'numeric',
						hour: 'numeric',
						minute: 'numeric'
					})}
				</p>
			</div>
			{history && (
				<div className="flex flex-row mx-4">
					<label>انتخاب تاریخ: </label>
					<DatePicker
						timePicker={false}
						value={moment(date)}
						className="p-1 mx-3 font-bold text-center rounded shadow"
						onClickSubmitButton={async ({ value }) => {
							const stringDate = value.format('YYYY-MM-DD');
							setDate(stringDate);
							history && routerHistory.push('/history?date=' + stringDate);
						}}
					/>
				</div>
			)}
			{users.map((user) => (
				<UserItem key={user?.patient.id} patient={user?.patient} created={user?.created} />
			))}
		</div>
	);
};

const UserItem: React.FunctionComponent<Partial<UsersType>> = ({ patient, created }) => {
	return (
		<Link
			key={patient?.id}
			to={`/patient/${patient?.id}`}
			className="grid grid-cols-1 p-1 mx-4 text-gray-200 rounded shadow-xl md:text-center py bg-cyan-600 md:grid-cols-3"
		>
			<span>
				نام: {patient?.first_name} {patient?.last_name}
			</span>
			<span>شماره تماس: {patient?.tel}</span>
			{created && (
				<span>
					زمان ورود:{' '}
					{new Date(created).toLocaleTimeString('fa', { timeZone: 'Asia/Tehran' }).slice(0, -3)}
				</span>
			)}
		</Link>
	);
};

export default Daily;
